const removeWhiteSpace = (string: string) =>
	string.replace(/\s/g, "").replace(/\t/g, "").replace(/\n/g, "")

export default removeWhiteSpace
